export default class AttivitaIntervento{
    
    Reparto;
    Comparto;
    CodiceEntita;
    DescrizioneEntita;
    CodiceAttivita;
    DescrizioneAttivita;
    Note;
    SysChiaveglobale;
    NoteIntervento

    constructor(){}
}